// Lightweight slug + label list for cross-links (Footer, home #fabrics row) and
// route registration. Kept separate from clusterData.js so the full page content
// (intros, FAQs, fabric lists) loads only inside the lazy ClusterPage chunk and
// stays out of the home bundle. Order matches CLUSTER_PAGES in clusterData.js.
export const CLUSTER_META = [
  { slug: "spandex-by-the-pound", label: "Spandex by the pound" },
  { slug: "powernet-compression-fabric", label: "Powernet & compression" },
  { slug: "performance-athletic-spandex", label: "Performance & athletic" },
  { slug: "technical-fr-medical-military-spandex", label: "Technical, FR & military" },
  { slug: "spandex-prints", label: "Spandex prints" },
  { slug: "stretch-lace-trims-elastics", label: "Lace, trims & elastics" },
];
